export const bpoTranslations = {
    'pt-BR': {
        'bpo.login.back': 'Voltar',
        'bpo.login.heroLead': 'Sua carteira inteira',
        'bpo.login.heroHighlight': 'em um só painel.',
        'bpo.login.enter': 'Entrar',
        'bpo.login.badge': 'BPO FINANCEIRO + IA',
        'bpo.login.portfolio': 'Todos os clientes em um só lugar',
        'bpo.login.financial': 'Contas a pagar e a receber',
        'bpo.login.reconciliation': 'Conciliação bancária automática',
        'bpo.login.ai': 'Agente de IA para o BPO',
        'bpo.login.benefits': 'Benefícios VA/VR com recarga',
        'bpo.login.documents': 'Documentos e notas em tempo real',
        'bpo.login.integrated': 'Integrado ao Domínio Empresa',
        'bpo.login.scope': 'Escopo por cliente e operador',
        'bpo.login.humanSupport': 'Suporte humano',
        'bpo.return': 'Voltar para BPO',
        'bpo.privacy': 'Declaração de privacidade',
        'bpo.terms': 'Termos de uso',
        'bpo.clients': 'Meus Clientes',
        'bpo.clientsDescription': 'Gerencie suas empresas cliente',
        'bpo.configureClients': 'Configurar Clientes',
        'bpo.configureClientsDescription': 'Escolha a empresa na lista e envie o convite ao responsável legal.',
        'bpo.settings': 'Configurações',
        'bpo.settingsDescription': 'Gerencie as preferências do escritório.',
        'bpo.admissions': 'Admissões',
        'bpo.admissionsDescription': 'Acompanhe as admissões dos seus clientes e envie para a Folha.',
        'bpo.navigation': 'Navegação BPO',
        'bpo.expand': 'Expandir menu',
        'bpo.collapse': 'Recolher menu',
        'bpo.resize': 'Ajustar largura do menu',
        'bpo.user': 'Usuário',
        'bpo.operator': 'Operador',
        'bpo.signOut': 'Sair',
        'bpo.support': 'Suporte',
        'bpo.previousMonth': 'Mês anterior',
        'bpo.nextMonth': 'Próximo mês',
        'bpo.loading': 'Carregando empresas…',
        'bpo.loadError': 'Não foi possível carregar suas empresas.',
        'bpo.retry': 'Tentar novamente',
        'bpo.empty': 'Nenhuma empresa cliente ainda',
        'bpo.emptyDescription': 'As empresas aparecem aqui quando você possui acesso como operador no Domínio Empresa.',
        'bpo.operationError': 'Não foi possível abrir a empresa. Verifique seu acesso e tente novamente.',
        'bpo.search': 'Pesquisar por nome ou CNPJ',
        'bpo.integrationPending': 'Integração de produção pendente.',
        'bpo.summaryError': 'Não foi possível atualizar o resumo.',
        'bpo.summaryUnavailable': 'Resumo indisponível',
        'bpo.access': 'Acessar Sistema',
        'bpo.configure': 'Configurar',
        'bpo.opening': 'Abrindo…',
        'bpo.nfse': 'NFSe - Serviços',
        'bpo.issue': 'Emitir NFSe',
        'bpo.newAdmission': 'Nova Admissão',
        'bpo.benefits': 'Benefícios (VA/VR)',
        'bpo.recharge': 'Nova Recarga',
        'bpo.activeEmployees': 'Colaboradores ativos',
        'bpo.lastRecharge': 'Última recarga',
        'bpo.nextRecharge': 'Próxima recarga',
        'bpo.payables': 'Contas a Pagar',
        'bpo.receivables': 'Contas a Receber',
        'bpo.pay': 'Pagar',
        'bpo.receive': 'Receber',
        'bpo.hoje': 'Vencendo hoje:',
        'bpo.sete': 'Vencendo em 7 dias:',
        'bpo.atraso': 'Em atraso:',
        'bpo.login.title': 'Entrar no Domínio BPO',
        'bpo.login.hero': 'Sua carteira inteira em um só painel.',
        'bpo.login.description': 'O Domínio BPO conecta o escritório ao financeiro de cada cliente. Acompanhe contas a pagar e a receber, concilie extratos, aprove pagamentos e gerencie benefícios — tudo sem trocar de sistema.',
    },
    'en-US': {
        'bpo.login.back': 'Back',
        'bpo.login.heroLead': 'Your entire portfolio',
        'bpo.login.heroHighlight': 'in one dashboard.',
        'bpo.login.enter': 'Sign in',
        'bpo.login.badge': 'FINANCIAL BPO + AI',
        'bpo.login.portfolio': 'All clients in one place',
        'bpo.login.financial': 'Accounts payable and receivable',
        'bpo.login.reconciliation': 'Automatic bank reconciliation',
        'bpo.login.ai': 'AI agent for BPO',
        'bpo.login.benefits': 'VA/VR benefits and recharges',
        'bpo.login.documents': 'Documents and invoices in real time',
        'bpo.login.integrated': 'Integrated with Domínio Empresa',
        'bpo.login.scope': 'Access per client and operator',
        'bpo.login.humanSupport': 'Human support',
        'bpo.return': 'Return to BPO',
        'bpo.privacy': 'Privacy statement',
        'bpo.terms': 'Terms of use',
        'bpo.clients': 'My Clients',
        'bpo.clientsDescription': 'Manage your client companies',
        'bpo.configureClients': 'Configure Clients',
        'bpo.configureClientsDescription': 'Configure the companies you operate',
        'bpo.settings': 'Settings',
        'bpo.settingsDescription': 'Manage BPO users',
        'bpo.admissions': 'Admissions',
        'bpo.admissionsDescription': 'Track your clients’ admissions and send them to Payroll.',
        'bpo.navigation': 'BPO navigation',
        'bpo.expand': 'Expand menu',
        'bpo.collapse': 'Collapse menu',
        'bpo.resize': 'Adjust menu width',
        'bpo.user': 'User',
        'bpo.operator': 'Operator',
        'bpo.signOut': 'Sign out',
        'bpo.support': 'Support',
        'bpo.previousMonth': 'Previous month',
        'bpo.nextMonth': 'Next month',
        'bpo.loading': 'Loading companies…',
        'bpo.loadError': 'Could not load your companies.',
        'bpo.retry': 'Try again',
        'bpo.empty': 'No client companies yet',
        'bpo.emptyDescription': 'Companies appear here when you have operator access in Domínio Empresa.',
        'bpo.operationError': 'Could not open the company. Check your access and try again.',
        'bpo.search': 'Search by name or tax ID',
        'bpo.integrationPending': 'Production integration pending.',
        'bpo.summaryError': 'Could not update the summary.',
        'bpo.summaryUnavailable': 'Summary unavailable',
        'bpo.access': 'Access System',
        'bpo.configure': 'Configure',
        'bpo.opening': 'Opening…',
        'bpo.nfse': 'NFSe - Services',
        'bpo.issue': 'Issue NFSe',
        'bpo.newAdmission': 'New Admission',
        'bpo.benefits': 'Benefits (VA/VR)',
        'bpo.recharge': 'New Recharge',
        'bpo.activeEmployees': 'Active employees',
        'bpo.lastRecharge': 'Last recharge',
        'bpo.nextRecharge': 'Next recharge',
        'bpo.payables': 'Accounts Payable',
        'bpo.receivables': 'Accounts Receivable',
        'bpo.pay': 'Pay',
        'bpo.receive': 'Receive',
        'bpo.hoje': 'Due today:',
        'bpo.sete': 'Due within 7 days:',
        'bpo.atraso': 'Overdue:',
        'bpo.login.title': 'Sign in to Domínio BPO',
        'bpo.login.hero': 'All your companies. One overview.',
        'bpo.login.description': 'Manage your clients and financial operations in one place. Use your Domínio Empresa credentials.',
    },
    'es-ES': {
        'bpo.login.back': 'Volver',
        'bpo.login.heroLead': 'Toda su cartera',
        'bpo.login.heroHighlight': 'en un solo panel.',
        'bpo.login.enter': 'Entrar',
        'bpo.login.badge': 'BPO FINANCIERO + IA',
        'bpo.login.portfolio': 'Todos los clientes en un solo lugar',
        'bpo.login.financial': 'Cuentas por pagar y por cobrar',
        'bpo.login.reconciliation': 'Conciliación bancaria automática',
        'bpo.login.ai': 'Agente de IA para BPO',
        'bpo.login.benefits': 'Beneficios VA/VR con recarga',
        'bpo.login.documents': 'Documentos y facturas en tiempo real',
        'bpo.login.integrated': 'Integrado con Domínio Empresa',
        'bpo.login.scope': 'Acceso por cliente y operador',
        'bpo.login.humanSupport': 'Soporte humano',
        'bpo.return': 'Volver a BPO',
        'bpo.privacy': 'Declaración de privacidad',
        'bpo.terms': 'Términos de uso',
        'bpo.clients': 'Mis Clientes',
        'bpo.clientsDescription': 'Gestione sus empresas cliente',
        'bpo.configureClients': 'Configurar Clientes',
        'bpo.configureClientsDescription': 'Configure las empresas que opera',
        'bpo.settings': 'Configuración',
        'bpo.settingsDescription': 'Gestione los usuarios de BPO',
        'bpo.admissions': 'Admisiones',
        'bpo.admissionsDescription': 'Siga las admisiones de sus clientes y envíelas a Nómina.',
        'bpo.navigation': 'Navegación BPO',
        'bpo.expand': 'Expandir menú',
        'bpo.collapse': 'Contraer menú',
        'bpo.resize': 'Ajustar ancho del menú',
        'bpo.user': 'Usuario',
        'bpo.operator': 'Operador',
        'bpo.signOut': 'Salir',
        'bpo.support': 'Soporte',
        'bpo.previousMonth': 'Mes anterior',
        'bpo.nextMonth': 'Próximo mes',
        'bpo.loading': 'Cargando empresas…',
        'bpo.loadError': 'No se pudieron cargar sus empresas.',
        'bpo.retry': 'Intentar de nuevo',
        'bpo.empty': 'Aún no hay empresas cliente',
        'bpo.emptyDescription': 'Las empresas aparecen aquí cuando tiene acceso como operador en Domínio Empresa.',
        'bpo.operationError': 'No se pudo abrir la empresa. Verifique su acceso e intente de nuevo.',
        'bpo.search': 'Buscar por nombre o identificación fiscal',
        'bpo.integrationPending': 'Integración de producción pendiente.',
        'bpo.summaryError': 'No se pudo actualizar el resumen.',
        'bpo.summaryUnavailable': 'Resumen no disponible',
        'bpo.access': 'Acceder al Sistema',
        'bpo.configure': 'Configurar',
        'bpo.opening': 'Abriendo…',
        'bpo.nfse': 'NFSe - Servicios',
        'bpo.issue': 'Emitir NFSe',
        'bpo.newAdmission': 'Nueva Admisión',
        'bpo.benefits': 'Beneficios (VA/VR)',
        'bpo.recharge': 'Nueva Recarga',
        'bpo.activeEmployees': 'Colaboradores activos',
        'bpo.lastRecharge': 'Última recarga',
        'bpo.nextRecharge': 'Próxima recarga',
        'bpo.payables': 'Cuentas por Pagar',
        'bpo.receivables': 'Cuentas por Cobrar',
        'bpo.pay': 'Pagar',
        'bpo.receive': 'Cobrar',
        'bpo.hoje': 'Vencen hoy:',
        'bpo.sete': 'Vencen en 7 días:',
        'bpo.atraso': 'Vencidas:',
        'bpo.login.title': 'Entrar en Domínio BPO',
        'bpo.login.hero': 'Todas sus empresas. Una sola visión.',
        'bpo.login.description': 'Gestione sus clientes y operaciones financieras en un solo lugar. Use su acceso de Domínio Empresa.',
    },
};
